<template>
  <v-container>
    <h1 v-if="!vendor.id">Lag ny butikk</h1>
    <h1 v-if="vendor.id">Rediger butikk: {{ vendor.name }}</h1>

    <AdminBreadcrumbs v-if="vendor.id" :vendor="vendor" :items="breadcrumbs" />
    <AdminBreadcrumbs v-else :items="breadcrumbs" />

    <v-card class="orange lighten-5" elevation="3">
      <v-form ref="form" lazy-validation @submit.prevent="submit">
        <v-card-title v-if="vendor.id" class="white--text orange"
          >Rediger butikk</v-card-title
        >
        <v-card-title v-else class="white--text orange"
          >Lag ny butikk</v-card-title
        >

        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="vendor.name"
                :rules="[rules.required]"
                label="Navn"
                required
                :disabled="isSaving"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="vendor.description"
                label="Beskrivelse"
                hint="Tekst som viser over produktene i butikken din."
                :disabled="isSaving"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-container>

        <v-card-actions>
          <v-btn type="submit" color="success" :loading="isSaving">
            <v-icon left> mdi-content-save </v-icon>
            Lagre
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn
            v-if="vendor.id"
            color="error"
            :loading="isSaving"
            @click="deleteVendor"
          >
            <v-icon left> mdi-delete </v-icon>
            Slett
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import backend from "../backend";
import AdminBreadcrumbs from "./AdminBreadcrumbs";

export default {
  name: "AdminVendorEdit",

  components: {
    AdminBreadcrumbs,
  },

  props: {
    vendorId: {
      type: String,
      required: false,
      default: "",
    },
  },

  data: function () {
    return {
      vendor: {},
      isSaving: false,
      rules: {
        required: (v) => !!v || "Required",
      },
    };
  },

  computed: {
    breadcrumbs() {
      let crumbs = [];

      if (this.vendorId) {
        crumbs.push({
          text: "Rediger butikk",
          disabled: true,
        });
      } else {
        crumbs.push({
          text: "Butikker",
          disabled: false,
          to: { name: "adminVendors" },
          exact: true,
        });

        crumbs.push({
          text: "Lag ny butikk",
          disabled: true,
        });
      }

      return crumbs;
    },
  },

  async created() {
    if (this.vendorId) {
      this.vendor = await backend.get(`vendors/${this.vendorId}/`);
    }
  },

  methods: {
    async submit() {
      if (this.$refs.form.validate()) {
        let msg = undefined;

        if (this.vendor.id) {
          this.vendor = await backend.put(
            `vendors/${this.vendor.id}/`,
            {
              name: this.vendor.name,
              description: this.vendor.description,
              organization: this.vendor.organization,
            },
            {
              vendor: this.vendorId,
            }
          );

          msg = "Butikken er nå lagret.";
        } else {
          this.vendor = await backend.post("vendors/", {
            name: this.vendor.name,
          });

          msg = "Butikken er nå opprettet.";
        }

        this.$router.push({
          name: "adminVendorDetail",
          params: {
            vendorId: this.vendor.id.toString(),
          },
        });

        this.$store.dispatch("add", {
          type: "success",
          message: msg,
        });
      }
    },

    async deleteVendor() {
      await backend.del(
        `vendors/${this.vendor.id}/`,
        {},
        { vendor: this.vendor.id }
      );

      this.$router.push({
        name: "adminVendors",
      });

      this.$store.dispatch("add", {
        type: "success",
        message: "Vendor er slettet",
      });
    },
  },
};
</script>

